import React from 'react';

const LoginArt = () => {
  return (
    <div className="flex items-center justify-center h-[400px] w-[400px] bg-transparent">
      <img src="/Picture1 copy.png" alt="Login Art" className="w-full h-full object-contain" />
    </div>
  );
};

export default LoginArt;


